import { render, staticRenderFns } from "./photodiago.vue?vue&type=template&id=00c421ee&scoped=true"
import script from "./photodiago.vue?vue&type=script&lang=js"
export * from "./photodiago.vue?vue&type=script&lang=js"
import style0 from "./photodiago.vue?vue&type=style&index=0&id=00c421ee&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c421ee",
  null
  
)

export default component.exports